import { useComboBoxState as originalUseComboBoxState } from '@react-stately/combobox';

/**
 * A wrapper for `useComboBoxState` to make the combobox more like "autocomplete":
 *
 * 1) We don't want to allow opening the combobox "manually".
 * In react-aria terms "manual" opening means where the user explicitly
 * wants to open the popover.
 * In the autocomplete feature we don't want such behaviour because the
 * popover has the role of assisting typing, not "selecting" a value.
 *
 * 2) We don't want to show any options if the query is empty.
 *
 * More details here
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/combobox/src/useComboBox.ts
 */
export const useComboBoxState: typeof originalUseComboBoxState = (options) => {
  const state = originalUseComboBoxState({
    ...options,
    defaultFilter: (textValue, query) => {
      if (query.length > 0) {
        return options.defaultFilter
          ? options.defaultFilter(textValue, query)
          : textValue.toLowerCase().includes(query.toLowerCase());
      } else {
        return false;
      }
    },
  });
  return {
    ...state,
    open: (focusStrategy, triggerMode) => {
      if (triggerMode !== 'manual') {
        state.open(focusStrategy, triggerMode);
      }
    },
  };
};
